import React from 'react'
import { observer } from 'mobx-react'
import { ListItem, ListItemSegment } from 'components/ListItem'
import formatCurrency from 'utils/formatCurrency'
import './styles.sass'

const Amendments = observer(function Amendments ({ amendments }) {
  if (amendments.length === 0) {
    return (
      <div className="no-amendments">
        <div className="no-amendments__icon">
          <img src={require('assets/icons/amendments.png')} />
        </div>
        <div className="no-amendments__title">
          Amendments
        </div>
        <div className="no-amendments__description">
          <p>
            If you would like to request additional services, ask your Pro or
            contact support and we will hook you up!
          </p>
          <hr/>
          <p><strong>For example...</strong></p>
          <ul>
            <li>Estimated payments</li>
            <li>ITIN application</li>
            <li>Incorporation</li>
            <li>Additional bookkeeping</li>
          </ul>
        </div>
      </div>
    )
  }
  return (
    <div className="amendments">
      {amendments.map(a =>
        <Amendment amendment={a} key={a.id} />
      )}
    </div>
  )
})

export default Amendments

const Amendment = observer(function Amendment ({ amendment }) {
  return (
    <ListItem className="amendment" border>
      <ListItemSegment pad stretch>
        <div className="amendment__description">{amendment.description}</div>
        <div className="amendment__date">{amendment.dateCreated.format('L LT')}</div>
      </ListItemSegment>
      <ListItemSegment pad>
        <div className="amendment__price">
          {formatCurrency(amendment.customerAmount)}
        </div>
      </ListItemSegment>
    </ListItem>
  )
})



// WEBPACK FOOTER //
// ./src/client/screens/ProjectDetails/Amendments/index.jsx